import * as Flags from "country-flag-icons/react/3x2"
import { DEFAULT_AGENT_ID } from "../constants/agent"

export enum AgentLanguages {
  Arabic = "ar",
  Bengali = "bn",
  Bulgarian = "bg",
  Chinese = "zh",
  Czech = "cs",
  Danish = "da",
  Dutch = "nl",
  English = "en",
  EnglishAustralia = "en-AU",
  EnglishCanada = "en-CA",
  EnglishUnitedKingdom = "en-GB",
  Finnish = "fi",
  French = "fr",
  FrenchCanada = "fr-CA",
  German = "de",
  Greek = "el",
  Hindi = "hi",
  Indonesian = "id",
  Italian = "it",
  Japanese = "ja",
  Kazakh = "kk",
  Korean = "ko",
  Malay = "ms",
  Polish = "pl",
  Portuguese = "pt",
  PortugueseBrazil = "pt-BR",
  PortuguesePortugal = "pt-PT",
  Romanian = "ro",
  Russian = "ru",
  Slovak = "sk",
  Spanish = "es",
  Swedish = "sv",
  Turkish = "tr",
  Urdu = "ur",
  Ukrainian = "uk",
  Uzbek = "uz",
}

export const CountryFlags: Record<AgentLanguages, Flags.FlagComponent> = {
  [AgentLanguages.Arabic]: Flags.SA,
  [AgentLanguages.Bengali]: Flags.BN,
  [AgentLanguages.Bulgarian]: Flags.BG,
  [AgentLanguages.Chinese]: Flags.CN,
  [AgentLanguages.Czech]: Flags.CZ,
  [AgentLanguages.Danish]: Flags.DK,
  [AgentLanguages.Dutch]: Flags.NL,
  [AgentLanguages.English]: Flags.US,
  [AgentLanguages.EnglishAustralia]: Flags.AU,
  [AgentLanguages.EnglishCanada]: Flags.CA,
  [AgentLanguages.EnglishUnitedKingdom]: Flags.GB,
  [AgentLanguages.Finnish]: Flags.FI,
  [AgentLanguages.French]: Flags.FR,
  [AgentLanguages.FrenchCanada]: Flags.CA,
  [AgentLanguages.German]: Flags.DE,
  [AgentLanguages.Greek]: Flags.GR,
  [AgentLanguages.Hindi]: Flags.IN,
  [AgentLanguages.Indonesian]: Flags.ID,
  [AgentLanguages.Italian]: Flags.IT,
  [AgentLanguages.Japanese]: Flags.JP,
  [AgentLanguages.Kazakh]: Flags.KZ,
  [AgentLanguages.Korean]: Flags.KR,
  [AgentLanguages.Malay]: Flags.MY,
  [AgentLanguages.Polish]: Flags.PL,
  [AgentLanguages.Portuguese]: Flags.PT,
  [AgentLanguages.PortugueseBrazil]: Flags.BR,
  [AgentLanguages.PortuguesePortugal]: Flags.PT,
  [AgentLanguages.Romanian]: Flags.RO,
  [AgentLanguages.Russian]: Flags.RU,
  [AgentLanguages.Slovak]: Flags.SK,
  [AgentLanguages.Spanish]: Flags.ES,
  [AgentLanguages.Swedish]: Flags.SE,
  [AgentLanguages.Turkish]: Flags.TR,
  [AgentLanguages.Urdu]: Flags.PK,
  [AgentLanguages.Ukrainian]: Flags.UA,
  [AgentLanguages.Uzbek]: Flags.UZ,
}

export const initialAgent = {
  id: DEFAULT_AGENT_ID,
  name: "Demo Agent",
  owner: { type: "demo" as const },
  language: AgentLanguages.English,
}

export interface AgentOwner {
  type: "demo" | "creator"
  id?: string
}

export interface CustomBranding {
  allow_bey_branding?: boolean
  logo_url?: string | null
  background_url?: string | null
  brand_color?: string | null
  accent_color?: string | null
  font_color?: string | null
  font_family?: string | null
  font_url?: string | null
  brand_website?: string | null
  brand_email?: string | null
  title?: string | null
  favicon_url?: string | null
  brand_button_text?: string | null
  brand_button_url?: string | null
  enable_contact_form?: boolean
}

export interface Agent {
  id: string
  owner?: AgentOwner
  name?: string
  description?: string
  mode?: string
  greeting?: string
  avatarId?: string
  knowledgeIds?: string[]
  active?: boolean
  max_session_length_minutes?: number | null
  number_of_sessions?: number
  notification_threshold_sessions?: number
  language: AgentLanguages | null
  avatar_video_url?: string | null
  agent_background_url?: string | null
  custom_branding?: CustomBranding | null
}
